import { getMockDataByKeys } from "./mock";

export const NOTIFY = {
  name: "notify",
  uuid: 0x7101,
  properties: ["read", "write", "notify"],
};
export function generateMockADANofifyData(): DomianControl.AWSNotifyData {
  const data = getMockDataByKeys(
    [
      /**
       * 纵向加速度
       */
      "UIRx_ACULongdAcc",
      /**
       * 制动踏板开度
       */
      "UIRx_BrkPdlPositionAct",
      /**
       * 车辆Standstill
       */
      "UIRx_VehSdsl",
    ],
    { UIRx_ACULongdAcc: [-1, 1] }
  );
  return data;
}
